// extracted by mini-css-extract-plugin
export default {"container":"getSuccessNotificationNode_container__XFqrO"};